import { useEffect, useState } from 'react'
import { api, type AuthEntryResponse } from '../api/client'

export type AuthEntryState =
  | { status: 'loading' }
  | { status: 'ready'; entry: AuthEntryResponse }
  | { status: 'failed' }

/**
 * Co ten HOST oznacza dla logowania (`GET /auth/entry`): adres obszaru firmy
 * czy apeks. Pytamy serwer, bo tylko on zna `APP_BASE_DOMAIN` i zastrzeżone
 * etykiety — zgadywanie z `window.location` dawało błędne odpowiedzi pod
 * compose (`localhost` kontra `*.k1p4.localhost`, komentarz w routes/auth.ts).
 */
export function useAuthEntry(): AuthEntryState {
  const [state, setState] = useState<AuthEntryState>({ status: 'loading' })

  useEffect(() => {
    const controller = new AbortController()
    api
      .authEntry(controller.signal)
      .then((entry) => setState({ status: 'ready', entry }))
      .catch(() => {
        if (!controller.signal.aborted) setState({ status: 'failed' })
      })
    return () => {
      controller.abort()
    }
  }, [])

  return state
}

/**
 * Dokąd prowadzi logo i „strona główna" na TYM hoście. Na adresie firmy `/`
 * od razu rusza logowanie przez portal (HostEntry), więc logo nad ekranem
 * błędu logowania restartowałoby ten sam przepływ — tam „domem" jest `/login`.
 */
export function useHomePath(): string {
  const state = useAuthEntry()
  return state.status === 'ready' && state.entry.tenantHost ? '/login' : '/'
}
